import { objectOf, maybe, arrayOf } from "@altostra/type-validations";
import { boolean, string, any, number } from "@altostra/type-validations/lib/primitives";

import type { SubscriptionGroupBase } from "../usersSubscriptionGroupsData";

const bsonId = string;
export const isUsersSubscriptionGroupDataResult = objectOf<SubscriptionGroupBase>({
  id: bsonId,
  name: string,
  channel: number,
  ext_id: bsonId,
  ag_id: bsonId,
  from_addresses: any,
  link_shortening_domain: maybe(string),
  sms_allowed_countries: maybe(arrayOf(string)),
  is_rcs_enabled: maybe(boolean),
  is_byoa_enabled: maybe(boolean),
  is_archived: boolean,
  can_edit: boolean,
  desc: string,
});
